import { SegmentedTabs } from '@skupreme/shared/ui';
import { useAuth } from '@contexts/auth';
import {
  canPickPageView,
  type PageView,
  readPageView,
  savePageView,
} from '@utility/page-view';
import { usePageVersions } from '../use-page-versions';

const ITEMS = [
  { id: 'v2', label: 'V2' },
  { id: 'legacy', label: 'V1' },
];

/*
 * EN-4134: a superadmin's switch between a V2 account's pages and the legacy
 * ones. The whole app reloads, so every page asks again with the new view.
 * Not on production, where everyone is on V2.
 */
export function VersionPicker() {
  const { isSuperAdmin } = useAuth() as { isSuperAdmin?: boolean };
  const { hasV2 } = usePageVersions();

  if (!isSuperAdmin || !hasV2 || !canPickPageView()) {
    return null;
  }

  return (
    <SegmentedTabs
      label="Version"
      selectedKey={readPageView()}
      items={ITEMS}
      onSelectionChange={key => {
        if (key === readPageView()) return;
        savePageView(key as PageView);
        window.location.reload();
      }}
    />
  );
}
